export const unformattedPhoneNumber = (phoneNumber: number | string) => {
  const pn = phoneNumber.toString();
  return pn.replace(/\D/g, '');
};

export const formatPhoneNumber = (phoneNumber: number | string) => {
  const cleaned = unformattedPhoneNumber(phoneNumber);

  if (!cleaned) return '';

  const areaCode = cleaned.slice(0, 3);
  const p1 = cleaned.slice(3, 6);
  const p2 = cleaned.slice(6, 10);

  return `${areaCode ? '(' + areaCode : ''}${p1 ? ')-' + p1 : ''}${p2 ? '-' + p2 : ''}`;
};
